import { PAYPAL_PAYMENT_SUCCESS, PAYPAL_PAYMENT_ERROR } from '../../constants/ActionTypes';

export const paypalPaymentSuccess = (paymentDetails) => ({
  type: PAYPAL_PAYMENT_SUCCESS,
  payload: paymentDetails
});

export const paypalPaymentError = (error) => ({
  type: PAYPAL_PAYMENT_ERROR,
  payload: error
});